/**
 * The file used for the talk while muted sound notification.
 *
 * @type {string}
 */
export const TALK_WHILE_MUTED_SOUND_FILE = 'talkWhileMuted.mp3';
